import { f as t } from "./function-uncurry-this.js";
import { d as r } from "./define-built-ins.js";
import { i as n } from "./internal-metadata.js";
import { a as i } from "./an-instance.js";
import { a as e } from "./an-object.js";
import { i as o } from "./is-null-or-undefined.js";
import { i as s } from "./is-object.js";
import { i as a } from "./iterate.js";
import { a as f } from "./array-iteration.js";
import { h as u } from "./has-own-property.js";
import { i as c } from "./internal-state.js";
var m = n.getWeakData,
  d = c.set,
  p = c.getterFor,
  h = f.find,
  v = f.findIndex,
  j = t([].splice),
  l = 0,
  g = function g(t) {
    return t.frozen || (t.frozen = new y());
  },
  y = function y() {
    this.entries = [];
  },
  b = function b(t, r) {
    return h(t.entries, function (t) {
      return t[0] === r;
    });
  };
y.prototype = {
  get: function get(t) {
    var r = b(this, t);
    if (r) return r[1];
  },
  has: function has(t) {
    return !!b(this, t);
  },
  set: function set(t, r) {
    var n = b(this, t);
    n ? n[1] = r : this.entries.push([t, r]);
  },
  delete: function _delete(t) {
    var r = v(this.entries, function (r) {
      return r[0] === t;
    });
    return ~r && j(this.entries, r, 1), !!~r;
  }
};
var z = {
  getConstructor: function getConstructor(t, n, f, c) {
    var h = t(function (t, r) {
        i(t, v), d(t, {
          type: n,
          id: l++,
          frozen: void 0
        }), o(r) || a(r, t[c], {
          that: t,
          AS_ENTRIES: f
        });
      }),
      v = h.prototype,
      j = p(n),
      y = function y(t, r, n) {
        var i = j(t),
          o = m(e(r), !0);
        return !0 === o ? g(i).set(r, n) : o[i.id] = n, t;
      };
    return r(v, {
      delete: function _delete(t) {
        var r = j(this);
        if (!s(t)) return !1;
        var n = m(t);
        return !0 === n ? g(r).delete(t) : n && u(n, r.id) && delete n[r.id];
      },
      has: function has(t) {
        var r = j(this);
        if (!s(t)) return !1;
        var n = m(t);
        return !0 === n ? g(r).has(t) : n && u(n, r.id);
      }
    }), r(v, f ? {
      get: function get(t) {
        var r = j(this);
        if (s(t)) {
          var n = m(t);
          return !0 === n ? g(r).get(t) : n ? n[r.id] : void 0;
        }
      },
      set: function set(t, r) {
        return y(this, t, r);
      }
    } : {
      add: function add(t) {
        return y(this, t, !0);
      }
    }), h;
  }
};
export { z as c };